import React, { useEffect, useState, useMemo } from 'react'
import SimpleBarFilterCustom from '../../../components/Common/SimpleBarFilterCustom'
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row
} from 'reactstrap'
import ProgressBar from '../../../components/Common/ProgressBar'
import InputSearch from '../../../components/Inputs/InputSearch'
import HeaderDefaultToPage from '../../../components/Common/headerDefaultToPage'
import PreFilterBadge from '../../../components/Common/PreFilterBadge'
import { exportGridToExcel, exportGridToCSV, exportGridToHTML } from '../../../components/Utils/export'
import TranspaleStringToComponente from '../../../components/Dynamic/TranspaleStringToComponente'
import { maxDate } from '../../../helpers/functions'
import { useSelector } from 'react-redux'
import DragDropReorderTable from '../../../components/Dynamic/DragDropReorderTable'
import BizinBackend from '../../../helpers/bizin_helper'

const EXPORT_COLUMNS = [
  { field: "Status", header: "Status", width: '5%', hasImage: true, Export: true },
  { field: "Protocolo", header: "Protocolo", Export: true },
  { field: "Tipo_Agendamento", header: "Tipo Ag.", Export: true },
  { field: "Fornecedor", header: "Fornecedor", Export: true },
  { field: "Destino", header: "Destino", hasImage: true, Export: true },
  { field: "Entrega", header: "Entrega", Export: true },
  { field: "Desembarque", header: "Desembarque", Export: true },
  { field: "SKUs", header: "SKUs", Export: true },
  { field: "Qtde_SKUs", header: "Qtd. SKUS", Export: true },
  { field: "Qtde_Volumes", header: "Qt. Vol.", Export: true },
  { field: "Categoria", header: "Categoria", Export: true },
  { field: "Peso_Total", header: "Peso", Export: true },
  { field: "Valor", header: "Valor", Export: true },
  { field: "Dt_Agend", header: "Dt. Agend.", Export: true },
  { field: "Coluna_Funcoes", header: "Funções", width: '5%', hasImage: true, Export: false },
]

export default function GridHeader({ context }) {
  const {
    isLoading,
    paramsOnFilter,
    setParamsOnFilter,
    setTriggerOnFilter,
    setIsOpenModal,
    isOpenModal,
    setInputGlobalSearchValue,
    filteredData,
    userProfile,
    columns,
    setColumns,
    csrfToken,
    accessToken
  } = React.useContext(context)

  const [preFilter, setPreFilter] = useState([])
  const [btnActionExport, setBtnActionExport] = useState(false)
  const [btnActionPresetTable, setBtnActionPresetTable] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [exportProgress, setExportProgress] = useState(0)
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [progressMessage, setProgressMessage] = useState('')
  const [advancedFilters, setAdvancedFilters] = useState(false)
  const isIframePage = useSelector(state => state.Layout.isIframePage)
  const pageTitle = 'Consulta de Agendamento'

  const maxStartDate = useMemo(() => {
    const endDate = preFilter?.[0]?.Filtro_Data_Termino?.value ?? preFilter?.[0]?.Data_Termino?.value;
    return endDate ? endDate.split('/').reverse().join('-') : new Date().toISOString().split('T')[0];
  }, [preFilter]);

  const handleExport = async (item) => {
    try {
      setIsExporting(true)
      setShowProgressBar(true)
      setExportProgress(0)

      const icone = item?.icone || ''
      const label = (item?.label || '').toLowerCase()
      const transactionCode = "DF_OT0012"

      const options = {
        title: pageTitle,
        transactionCode,
        appliedFilters: paramsOnFilter,
        filteredData,
        columns: EXPORT_COLUMNS
      }

      setExportProgress(5)
      await new Promise(resolve => setTimeout(resolve, 100))

      if (icone.includes('fa-file-pdf') || label.includes('pdf')) {
        setExportProgress(30)
        setProgressMessage('Gerando PDF...')
        await new Promise(resolve => setTimeout(resolve, 200))
        await exportGridToHTML({ ...options, filename: 'relatorio.pdf' })
        setExportProgress(90)
        setProgressMessage('Concluído!')
        await new Promise(resolve => setTimeout(resolve, 200))
      } else if (icone.includes('fa-file-excel') || label.includes('excel') || label.includes('xlsx')) {
        setExportProgress(30)
        await new Promise(resolve => setTimeout(resolve, 200))
        exportGridToExcel({ ...options, filename: 'relatorio.xlsx' })
        setExportProgress(90)
        await new Promise(resolve => setTimeout(resolve, 200))
      } else if (icone.includes('fa-file-csv') || label.includes('csv')) {
        setExportProgress(30)
        await new Promise(resolve => setTimeout(resolve, 200))
        exportGridToCSV({ ...options, filename: 'relatorio.csv' })
        setExportProgress(90)
        await new Promise(resolve => setTimeout(resolve, 200))
      } else if (icone.includes('fa-file-code') || label.includes('html')) {
        setExportProgress(30)
        setProgressMessage('Gerando HTML...')
        await new Promise(resolve => setTimeout(resolve, 200))
        await exportGridToHTML({ ...options, filename: 'relatorio.html', convertToPdf: false })
        setExportProgress(90)
        setProgressMessage('Concluído!')
        await new Promise(resolve => setTimeout(resolve, 200))
      }

      setExportProgress(100)
    } catch (error) {
      console.error('Erro na exportação:', error)
    } finally {
      setIsExporting(false)
      setBtnActionExport(false)
      setShowProgressBar(false)
      setExportProgress(0)
      setProgressMessage('')
    }
  }

  const onSubmitFilter = data => {
    setIsOpenModal(false)
    setParamsOnFilter([{ ...data[0] }])
    setTriggerOnFilter(true)
  }

  const onClearFilter = () => {
    const hoje = new Date().toLocaleDateString()
    setParamsOnFilter([{
      Filtro_Data_Inicio: { value: hoje, field: "De" },
      Filtro_Data_Termino: { value: hoje, field: "Até" },
      Filtro_Status: [{
        field: "Status",
        values: [{ value: 'A', label: 'Aprovado' }]
      }]
    }])
    setPreFilter([{
      Filtro_Data_Inicio: { value: hoje, field: "De" },
      Filtro_Data_Termino: { value: hoje, field: "Até" },
      Filtro_Status: [{
        field: "Status",
        values: [{ value: 'A', label: 'Aprovado' }]
      }]
    }])
    setIsOpenModal(false)
    setTriggerOnFilter(true)
  }

  const handleUpdateConfigColumns = async (items) => {
    setColumns(items)
    try {
      await BizinBackend.executeProcedure(
        {
          1: userProfile.ID_Usuario,
          2: "DF_OT0012",
          3: 'Visão Customizada do Usuário',
          4: `${JSON.stringify(items)}`,
          5: 1,
        },
        'FRONT_Workspace_Salvar_Layout_Grid',
        csrfToken,
        accessToken
      )
    } catch (error) {
      console.log("erro ao carregar FRONT_Workspace_Salvar_Layout_Grid", error);
    }
  }

  const handleResetConfigColumns = async () => {
    try {
      const resp = await BizinBackend.executeProcedure(
        {
          1: userProfile.ID_Usuario,
          2: "DF_OT0012",
          3: 'Visão Customizada do Usuário'
        },
        'FRONT_Workspace_Deletar_Layout_Grid',
        csrfToken,
        accessToken
      )
      console.log("resp: coluna redefinida: ", resp)
      if (resp[0]['Novo_JSON_Configuracao']) setColumns(JSON.parse(resp[0]['Novo_JSON_Configuracao']))
    } catch (error) {
      console.log("erro ao carregar FRONT_Workspace_Salvar_Layout_Grid", error);
    }
  }

  useEffect(() => {
    const hoje = new Date().toLocaleDateString()
    setParamsOnFilter([{
      Filtro_Data_Inicio: { value: hoje, field: "De" },
      Filtro_Data_Termino: { value: hoje, field: "Até" },
      Filtro_Status: [{
        field: "Status",
        values: [{ value: 'A', label: 'Aprovado' }]
      }]
    }])
    setPreFilter([{
      Filtro_Data_Inicio: { value: hoje, field: "De" },
      Filtro_Data_Termino: { value: hoje, field: "Até" },
      Filtro_Status: [{
        field: "Status",
        values: [{ value: 'A', label: 'Aprovado' }]
      }]
    }])
    setTriggerOnFilter(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Row>
        <Col
          lg={12}
          className={`mb-3 nav-accordion-custom ${isLoading ? 'disabled' : ''}`}
        >
          <Row className={`d-flex align-items-center justify-content-between pb-3`}>
            <Col id="header-primary-title">
              <HeaderDefaultToPage
                goBack={isIframePage ? false : true}
                title={pageTitle}
              />
            </Col>
            <Col
              id="header-secundary-actions"
              lg={6}
              className="d-flex justify-content-end gap-3 align-items-center"
            >
              <Button
                onClick={() => onSubmitFilter(preFilter)}
                className="bg-transparent border-0 p-0 m-0"
              >
                <i className="fa-solid font-size-24 fa-rotate-right text-primary-dark"></i>
              </Button>
              <Button
                onClick={() => window.print()}
                className="bg-transparent border-0 p-0 m-0"
              >
                <i className="fas font-size-24 fa-print text-primary-dark"></i>
              </Button>
              <Dropdown
                isOpen={btnActionExport}
                toggle={() => setBtnActionExport(!btnActionExport)}
                className="dropdown-export-dynamic w-auto"
              >
                <DropdownToggle
                  className="bg-transparent border-0 p-0 m-0"
                  caret
                  disabled={isExporting}
                >
                  {isExporting ? (
                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                  ) : (
                    <i className="fas font-size-24 fa-save text-primary-dark"></i>
                  )}
                </DropdownToggle>
                <DropdownMenu transition={{ timeout: 300 }}>
                  <DropdownItem
                    onClick={() => handleExport({ icone: 'fa-solid fa-file-pdf', label: 'pdf' })}
                    className="d-flex align-items-center gap-3"
                  >
                    <i className={'fa-solid fa-file-pdf'}></i>
                    <span>PDF</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleExport({ icone: 'fa-solid fa-file-xls', label: 'excel' })}
                    className="d-flex align-items-center gap-3"
                  >
                    <i className={'fa-solid fa-file-xls'}></i>
                    <span>XLS</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleExport({ icone: 'fa-solid fa-file-csv', label: 'csv' })}
                    className="d-flex align-items-center gap-3"
                  >
                    <i className={'fa-solid fa-file-csv'}></i>
                    <span>CSV</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => handleExport({ icone: 'fa-solid fa-file-code', label: 'html' })}
                    className="d-flex align-items-center gap-3"
                  >
                    <i className={'fa-solid fa-file-code'}></i>
                    <span>HTML</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>

              <Dropdown
                isOpen={btnActionPresetTable}
                toggle={() => setBtnActionPresetTable(!btnActionPresetTable)}
                className="dropdown-preset-table w-auto"
              >
                <DropdownToggle
                  className="bg-transparent border-0 p-0 m-0"
                  caret
                >
                  <i className="fa-regular fa-table-columns text-primary-dark fas font-size-24"></i>
                </DropdownToggle>
                <DropdownMenu transition={{ timeout: 300 }}>
                  <div className="d-flex justify-content-end mb-3">
                    <button onClick={() => handleResetConfigColumns()} className="d-flex align-items-center gap-2 bg-transparent border-0">
                      <i className="fas fa-times text-color-cinza4 font-size-12"></i>
                      <span className="text-color-cinza4 font-size-12">Redefinir Colunas</span>
                    </button>
                  </div>
                  <DragDropReorderTable items={columns} callbackItems={(items) => handleUpdateConfigColumns(items)} />
                </DropdownMenu>
              </Dropdown>

              <form onSubmit={() => { }}>
                <InputSearch
                  placeholder={'Busca rápida'}
                  onChange={e => setInputGlobalSearchValue(e)}
                />
              </form>

              <SimpleBarFilterCustom
                isOpen={isOpenModal}
                onClose={setIsOpenModal}
                onSubmit={() => onSubmitFilter(preFilter)}
                onClearFilter={onClearFilter}
              >
                <Row className="m-0 mb-1 form-custom01-filter">
                  <div className="m-0 p-0">
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"Data_Inicio"}
                        elementProps={{
                          value: new Date().toLocaleDateString(),
                          type: 'Date',
                          title: "De",
                          id: "Filtro_Data_Inicio",
                          maxDate: maxStartDate,
                        }}
                        preFilter={preFilter}
                        onDefaultValue={(value) => setParamsOnFilter(state => [{ ...state[0], ...value }])}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"Data_Termino"}
                        elementProps={{
                          value: new Date().toLocaleDateString(),
                          type: 'Date',
                          title: "Até",
                          id: "Filtro_Data_Termino",
                          maxDate: maxDate(24),
                        }}
                        preFilter={preFilter}
                        onDefaultValue={(value) => setParamsOnFilter(state => [{ ...state[0], ...value }])}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"Status"}
                        elementProps={{
                          value: ['A'],
                          type: 'Combobox',
                          isMultiSelection: true,
                          title: "Status",
                          id: "Filtro_Status",
                          isDisabled: false,
                          dataOptions: [
                            { value: 'A', label: 'Aprovado' },
                            { value: 'C', label: 'Cancelado' },
                            { value: 'E', label: 'Entrega Total' },
                            { value: 'I', label: 'Entrega Incompleta' },
                            { value: 'P', label: 'Pendente' },
                            { value: 'R', label: 'Rejeitado' },
                            { value: 'V', label: 'Vencido' },
                            { value: 'X', label: 'Pré Agenda Expirada' },
                            { value: 'Y', label: 'Pré Agenda Atendida' }
                          ]
                        }}
                        preFilter={preFilter}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"ID_Tipo_Agendamento"}
                        elementProps={{
                          value: '',
                          type: 'Combobox',
                          isMultiSelection: true,
                          title: "Tipo de Agendamento",
                          id: "Filtro_ID_Tipo_Agendamento",
                          isDisabled: false,
                          procedure: "SRM_Obtem_Tipos_Agendamentos",
                          procedureParams: []
                        }}
                        preFilter={preFilter}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"ID_Empresa_Origem"}
                        elementProps={{
                          value: '',
                          type: 'Combobox',
                          title: "Empresa origem",
                          id: "Filtro_ID_Empresa_Origem",
                          isDisabled: false,
                          procedure: "FRONT_Componente_Combo_Empresas",
                          procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'ORIGEM', 'NF']
                        }}
                        preFilter={preFilter}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"ID_Planta_Origem"}
                        elementProps={{
                          value: '',
                          type: 'Combobox',
                          title: "Planta origem",
                          id: "Filtro_ID_Planta_Origem",
                          isDisabled: false,
                          procedure: "FRONT_Componente_Combo_Plantas",
                          procedureParams: [`${userProfile?.ID_Usuario}`, 'pt-BR', '<#Filtro_ID_Empresa_Origem#>', 'ORIGEM', 'NF'],
                          alienated: ["Filtro_ID_Empresa_Origem"]
                        }}
                        preFilter={preFilter}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"ID_Empresa_Destino"}
                        elementProps={{
                          value: '',
                          type: 'Combobox',
                          title: "Empresa destino",
                          id: "Filtro_ID_Empresa_Destino",
                          isDisabled: false,
                          procedure: "FRONT_Componente_Combo_Empresas",
                          procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'DESTINO', 'NF']
                        }}
                        preFilter={preFilter}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"ID_Planta_Destino"}
                        elementProps={{
                          value: '',
                          type: 'Combobox',
                          title: "Planta destino",
                          id: "Filtro_ID_Planta_Destino",
                          isDisabled: false,
                          procedure: "FRONT_Componente_Combo_Plantas",
                          procedureParams: [`${userProfile?.ID_Usuario}`, 'pt-BR', '<#Filtro_ID_Empresa_Destino#>', 'DESTINO', 'NF'],
                          alienated: ["Filtro_ID_Empresa_Destino"]
                        }}
                        preFilter={preFilter}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"Referencia"}
                        elementProps={{
                          value: '',
                          type: 'Input',
                          title: "Número Protocolo",
                          id: "Filtro_Protocolo",
                          isDisabled: false
                        }}
                        preFilter={preFilter}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <div className="mb-3">
                      <TranspaleStringToComponente
                        elementId={"Numero_NF"}
                        elementProps={{
                          value: '',
                          type: 'Input',
                          title: "Número Nota Fiscal",
                          id: "Filtro_Documento_Relacionado_Agendamento",
                          isDisabled: false
                        }}
                        preFilter={preFilter}
                        onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                      />
                    </div>
                    <hr />
                    <div className='d-flex justify-content-between cursor-pointer mb-3' onClick={() => setAdvancedFilters(!advancedFilters)}>
                      <small>Filtro avançado</small>
                      <i className={`fa-solid fa-${!advancedFilters ? 'plus' : 'minus'}`}></i>
                    </div>
                    {advancedFilters && (
                      <div className='px-2'>
                        <div className="mb-3">
                          <TranspaleStringToComponente
                            elementId={"ID_Categoria"}
                            elementProps={{
                              value: '',
                              type: 'Combobox',
                              title: "Categoria",
                              placeholder: "Selecione a empresa destino",
                              id: "Filtro_ID_Categoria",
                              isDisabled: false,
                              procedure: "FRONT_Obter_Categorias",
                              procedureParams: ['<#Filtro_ID_Empresa_Destino#>'],
                              alienated: ["Filtro_ID_Empresa_Destino"]
                            }}
                            preFilter={preFilter}
                            onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Row>
              </SimpleBarFilterCustom>
              <Button
                onClick={() => setIsOpenModal(true)}
                style={{ height: 40, width: 113 }}
                className="button-filter-action font-w-600 bg-primary-dark border-0 text-white px-4 btn-hover-primary"
              >
                Filtros
              </Button>
            </Col>
            <Col md={12}>
              {paramsOnFilter[0] && Object.keys(paramsOnFilter[0]).length !== 0 && (
                <div className="container-pre-filter-header" key={1}>
                  <div className="d-flex flex-wrap p-0 gap-2 align-items-center">
                    <button className="btn px-0 border-0 text-black fonto-w-500 font-size-12">
                      Filtros aplicados:
                    </button>
                    {Object.keys(paramsOnFilter[0]).map((key, i) => {
                      if (Array.isArray(paramsOnFilter[0][key])) {
                        return (
                          <div key={i}>
                            {paramsOnFilter[0][key][0].values.map(
                              (item, _i) => (
                                <PreFilterBadge
                                  key={_i}
                                  index={_i}
                                  field={paramsOnFilter[0][key][0].field}
                                  value={item.label || item.value}
                                  callback={index => {
                                    const obj = { ...paramsOnFilter[0] }
                                    const pre = { ...preFilter[0] }

                                    let values = pre[key][0]?.values || []
                                    values = values.filter(
                                      (_, i) => i !== index
                                    )

                                    obj[key] = [
                                      { ...obj[key][0], values: values }
                                    ]
                                    pre[key] = [
                                      { ...pre[key][0], values: values }
                                    ]

                                    if (values.length === 0) {
                                      delete obj[key]
                                      delete pre[key]
                                    }

                                    setPreFilter([pre])
                                    onSubmitFilter([obj])
                                  }}
                                />
                              )
                            )}
                          </div>
                        )
                      } else {
                        return (
                          <PreFilterBadge
                            key={i}
                            index={i}
                            field={paramsOnFilter[0][key].field}
                            label={paramsOnFilter[0][key]?.isSelect ? '' : key}
                            value={
                              paramsOnFilter[0][key].label ||
                              paramsOnFilter[0][key].value
                            }
                            callback={() => {
                              const obj = { ...paramsOnFilter[0] }
                              const pre = { ...preFilter[0] }
                              delete obj[key]
                              delete pre[key]
                              setPreFilter([pre])
                              onSubmitFilter([obj])
                            }}
                          />
                        )
                      }
                    })}
                  </div>
                </div>
              )}
            </Col>
          </Row>

          <ProgressBar
            progress={exportProgress}
            message={progressMessage || 'Gerando relatório...'}
            isVisible={showProgressBar}
            showPercentage={true}
            autoHide={true}
            className="export-progress-bar"
          />

        </Col>
      </Row>
    </>
  )
}